import React from "react";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";

const columns = [
  {
    accessorKey: "level",
    header: "Level",
    size: 40,
  },
  // {
  //   accessorKey: "position",
  //   header: "Position",
  //   size: 40,
  // },
  {
    accessorKey: "user_full_name",
    header: "Downline Name",
    size: 40,
  },
  // {
  //   accessorKey: "user_name",
  //   header: " Downline Username",
  //   size: 40,
  // },
  {
    accessorKey: "sponsor",
    header: "Sponsor",
    size: 40,
  },
  // {
  //   accessorKey: "placement",
  //   header: "Placement",
  //   size: 40,
  // },
  // {
  //     accessorKey: 'product_amount',
  //     header: "Product Amount",
  //     size: 40,
  // },

  {
    accessorKey: "package",
    header: "Package",
    size: 40,
  },
  {
    accessorKey: "date_of_joining",
    header: "Registration Date",
    size: 40,
  },
];

const Example = ({ data }) => {
  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      positionToolbarAlertBanner="bottom"
      renderTopToolbarCustomActions={({ table }) => (
        <Box
          sx={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}
        ></Box>
      )}
      enablePagination={false}
    />
  );
};

export default Example;
